import { render, staticRenderFns } from "./RemoveSnackbar.vue?vue&type=template&id=227c2c32&scoped=true&"
import script from "./RemoveSnackbar.vue?vue&type=script&lang=js&"
export * from "./RemoveSnackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227c2c32",
  null
  
)

export default component.exports